module.exports = __webpack_public_path__ + "static/media/book-h2o-detail1.12d5939c.jpg";